import React, { type PropsWithChildren } from 'react';

import { type Money, formatMoney } from '@betterment/js-runtime';
import { Button, Dialog, HStack, Heading, Link, Separator, Text, VStack } from '@betterment/samba-react';

import { urlBuilder } from '../../../../Shared/urlBuilder';

type Props = {
  availableBalance: Money;
  totalBalance: Money;
  anyPending: boolean;
};

export const DirectTradingCashDialog: React.FC<PropsWithChildren<Props>> = ({
  availableBalance,
  totalBalance,
  children,
}) => (
  <Dialog>
    {children}
    <Dialog.Content css={{ p: 'space.400', width: '50%' }}>
      <Dialog.Title>
        <Heading variant="title300">Cash</Heading>
      </Dialog.Title>
      <Separator css={{ width: '100%' }} />
      <Dialog.Description>
        <VStack css={{ gap: 'space.200', paddingY: 'space.300' }}>
          <HStack css={{ justifyContent: 'space-between', px: '0' }}>
            <Text variant="text100">Total balance</Text>
            <Text variant="text100">{formatMoney(totalBalance)}</Text>
          </HStack>
          <Text variant="text50" color="text.weak">
            This is the amount of available cash along with pending transactions.
          </Text>
        </VStack>
        <Separator css={{ width: '100%' }} />
        <VStack css={{ gap: 'space.200', paddingY: 'space.300' }}>
          <HStack css={{ justifyContent: 'space-between', px: '0' }}>
            <Text variant="text100">Available balance</Text>
            <Text variant="text100">{formatMoney(availableBalance)}</Text>
          </HStack>
          <Text variant="text50" color="text.weak">
            Available balance is FDIC-insured up to $250K at{' '}
            <Link href={urlBuilder.getTransferSweepProgramDisclosure()} target="_blank" rel="noopener noreferrer">
              sweep banks
            </Link>{' '}
            and doesn't earn interest.
          </Text>
        </VStack>
        <Separator css={{ width: '100%' }} />
        <Dialog.Close asChild={true}>
          <Button variant="solidSecondary" css={{ mt: 'space.300' }}>
            Close
          </Button>
        </Dialog.Close>
      </Dialog.Description>
    </Dialog.Content>
  </Dialog>
);
